import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { protectedResources } from '../auth-config';

@Injectable({
    providedIn: 'root'
})
export class CandidatesService {
    private readonly apiUrl = 'https://new.dev.api.onboard.yourexpats.nl/api/candidates?tenant=51eb07f0-8dd3-496f-9708-cb99e62ad9a0';

    constructor(private http: HttpClient, private msalService: MsalService) { }

    getCandidates(): Observable<any> {
        return this.getToken().pipe(
            switchMap((accessToken: string) => {
                const headers = new HttpHeaders({
                    Authorization: `Bearer ${accessToken}`
                });
                return this.http.get(this.apiUrl, { headers });
            })
        );
    }

    private getToken(): Observable<string> {
        const account = this.msalService.instance.getActiveAccount();

        if (!account) {
            const authRequest = { scopes: protectedResources.myApi.scopes } as SilentRequest;
            this.msalService.loginRedirect(authRequest);
            return throwError(() => new Error('No active account. Redirecting to login.'));
        }

        const silentRequest: SilentRequest = {
            scopes: protectedResources.myApi.scopes,
            account
        } as SilentRequest;

        return from(this.msalService.instance.acquireTokenSilent(silentRequest)).pipe(
            catchError(() => from(this.msalService.instance.acquireTokenPopup(silentRequest))),
            switchMap((authResult: AuthenticationResult) => {
                return from([authResult.accessToken]);
            }),
            catchError(error => {
                console.error('Token acquisition failed:', error);
                return throwError(() => error);
            })
        );
    }
}
